import { FormsModule } from '@angular/forms';
import {
  Component, OnInit, Inject, Injectable, CUSTOM_ELEMENTS_SCHEMA, NgModule,
  Input//, trigger, state, style, transition, animate, keyframes,
} from '@angular/core';
//Rewrite Angular HTTP service after update
//import { Http, Headers, RequestOptions, Response, ResponseContentType } from '@angular/http';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'
import * as _ from 'underscore';
import { CommonSerivce } from '../shared/services/common.service'
import { UserService } from '../shared/services/user.service';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { GrowlModule } from 'primeng/growl';
import { FileUploadModule } from 'primeng/fileupload';
import { RadioButtonModule } from 'primeng/radiobutton';
import { EditorModule } from 'primeng/editor';
import { PaginatorModule } from 'primeng/paginator';
import { CalendarModule } from 'primeng/calendar';
import { FieldsetModule } from 'primeng/fieldset';
import { CheckboxModule } from 'primeng/checkbox';
import { DropdownModule } from 'primeng/dropdown';

import { DatePipe } from '@angular/common';
import { saveAs as importedSaveAs } from "file-saver";
import { Session } from 'inspector';

import { Router, ActivatedRoute } from '@angular/router';
import { TabView } from 'primeng/tabview';

import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

import * as XLSX from "xlsx-js-style";

import { JSDocTagName } from '@angular/compiler/src/output/output_ast';
import { Table } from 'primeng/table';
import { Header } from 'primeng/primeng';

@Component({
  selector: 'report',
  styleUrls: ['../shared/share.component.css'],
  providers: [CommonSerivce, UserService, DatePipe, ConfirmationService],
  templateUrl: './report.component.html'
})


export class ReportComponent {

  /*
      RecordList - Search result list
      SelectedRecordList - User selected record (Multiple) in the result table
      SelectedRecord - User selected record (Single) for edition
  */
  public OutstandingSeverityList: IOutstandingSeverity[];
  public CaseDetailsList: IDetailsReport[];
  public CaseSLAList: ISLAReport[];
  //public ExportOutstandingSeverityList: IOutstandingSeverity[];
  public InputErrorMsg: Message[] = [];

  //  Hold the value of the user inputted search field, to be used for searching
  public SearchFieldHolder: any;
  public SeveritySearchFields: ISeveritySearchFields;

  //Code value list for List Box, add required code value list
  public Reports_List: IReportsListValue[];
  public DomainList: IDomainValue[];
  public SeverityList: ICodeValue[];
  public CaseStatusList: ICodeValue[];


  /*
      sort0 - define the sorting sequence for the table field (1 asc, 0 desc)
      softF - define the sorting field name
  */
  sortO: number = 0;
  sortF: string = 'id';


  /*
      Major control variables
          FormTitle - Initial Form Title for the landing form
          PrimaryApiPath - Path for the API controller per component 
          ShowEditForm/ ShowAddForm - control whether to show Inquiry or Edit form
          ShowUploadForm - control whether to show Upload form
          AutoReload - control auto reload component
          
  */
  FormTitle: String = "Work With Reports";
  FormAccessRight: String = "NA";
  PrimaryApiPath: string = "api/BcpReport/";
  ListValueApiPath: string = "api/BcpListValue/";

  //Determine which report to show
  ShowSearchFields: Boolean = false;
  ShowOutstandingList: Boolean = false;
  ShowDetailsReport: Boolean = false;
  ShowSLAReport: Boolean = false;

  scrollHeight: string = "";
  scrollWidth: string = "";
  public CurrentForm: string = "BcpCase";

  httpOriginalUrl: String;
  httpHeaders = new Headers();
  isLoggedIn: boolean = false;
  dateFormat: String = "yy-mm-dd";

  arrayBuffer: any;
  uploadFile: File;

  cachedExpiryDate: String = "";

  //Display Warning/ Error Message
  public searchErrorMsgs: Message[] = [];
  public confirmMsgs: Message[] = [];
  public resultMsgs: Message[] = [];

  //Initialize Table Column Header
  public outstandingListCols: any;
  public caseDetailsCols: any;
  public caseSLACols: any;

  public selectedTab: string;
  public selectedReportName: string;
  public stringifyValue = "";

  //excel variable
  strLine: string;
  excelRow: string[] = [];
  SheetNames = [];
  Sheets = {};
  cellList: string[];
  lastRowNumber: number;
  currentProcessRow: number = -1;
  currentProcessColumn: number = -1;
  rangeFromColumn: number = -1;
  rangeFromRow: number = -1;
  rangeToColumn: number = -1;
  rangeToRow: number = -1;
  delimiter: string = "|";
  //excel variable - End

  processingFlag: string = "N";
  processingReport: string = "";
  listLength1: number = 0;
  numberOfSLACases: number = 0;

  constructor(private http: HttpClient, @Inject('BASE_URL') originUrl: string, private bcp: CommonSerivce, private datePipe: DatePipe, private confirmationService: ConfirmationService, private router: Router, private activatedRoute: ActivatedRoute) {
    //Rewrite Angular HTTP service after update
    //this.httpHeaders = this.bcp.getHttpHeader();

    this.httpOriginalUrl = originUrl;

    this.clearAllMessage();
    this.isLoggedIn = this.bcp.getLoginStatus();
    this.FormAccessRight = this.bcp.getAccessRightByProcess('REPORT');

    //get all list value for drop down list
    this.getCaseDomainList();
    this.getCaseStatusList('BCP');
    this.getCaseSeverityList('BCP');
    this.getReportsList();

    this.SearchFieldHolder = JSON.parse('{"id": 0}');
    this.SearchFieldHolder["domainId"] = this.bcp.getCurrentDomainId();
    this.SearchFieldHolder["fromDate"] = new Date(new Date().getFullYear(), 0, 1);
    this.SearchFieldHolder["toDate"] = new Date(new Date().getFullYear(), 11, 31);

    this.FormTitle = "Work With Reports";
    this.ShowSearchFields = true;
    this.selectedTab = "Outstanding List";
    this.getReportNamebyTab(this.selectedTab);       
    this.refreshSearchFields();

    this.scrollHeight = this.bcp.getDataTableHeight(0);//parameter: # of rows used for header search field
    this.scrollWidth = this.bcp.getDataTableWidth();

    this.outstandingListCols = [
      //{ field: 'action', header: 'Actions', width: '100', size: '5' },
      //{ field: 'id', header: 'ID', width: '75', size: '5' },
      { field: 'domainId', header: 'Domain', width: '100', size: '5' },
      { field: 'caseNumber', header: 'Case No.', width: '130', size: '10' },
      { field: 'subject', header: 'Subject', width: '350', size: '10' },
      { field: 'caseStatus', header: 'Status', width: '130', size: '10' },
      { field: 'severity', header: 'Severity', width: '130', size: '10' },
      { field: 'createDate', header: 'Create Date', width: '150', size: '10' },
      { field: 'targetDate', header: 'Target Date', width: '150', size: '10' },
      { field: 'longDescription', header: 'Description', width: '450', size: '10' }
    ];

    this.caseDetailsCols = [
      { field: 'caseNumber', header: 'Case No.', width: '130', size: '10' },
      { field: 'createDate', header: 'Create Date', width: '130', size: '10' },
      { field: 'longDescription', header: 'Description', width: '450', size: '10' },
      { field: 'serviceType', header: 'Type', width: '150', size: '10' },
      { field: 'subCategory1', header: 'Category', width: '150', size: '10' },
      { field: 'severity', header: 'Severity', width: '150', size: '10' },
      { field: 'caseStatus', header: 'Status', width: '150', size: '10' },
      { field: 'resolution', header: 'Resolution', width: '450', size: '10' },
      { field: 'technicalRemark', header: 'Related Objects', width: '150', size: '10' },
      { field: 'clientReferenceNumber', header: 'Client Reference', width: '150', size: '10' }
    ];

    this.caseSLACols = [
      { field: 'caseNumber', header: 'Case No.', width: '130', size: '10' },
      { field: 'issueDate', header: 'Issue Date', width: '150', size: '10' },
      { field: 'caseComplexity', header: 'Complexity', width: '100', size: '10' },
      { field: 'severity', header: 'Severity', width: '100', size: '10' },
      { field: 'serviceType', header: 'Type', width: '150', size: '10' },
      { field: 'caseStatus', header: 'Status', width: '130', size: '10' },
      { field: 'subject', header: 'Subject', width: '400', size: '10' },
      { field: 'responseDate', header: 'Response Date', width: '150', size: '10' },
      { field: 'responseHour', header: 'Response Hour', width: '100', size: '10' },
      { field: 'resolutionDate', header: 'Resolution Date', width: '150', size: '10' },
      { field: 'resolutionHour', header: 'Resolution Hour', width: '100', size: '10' }
    ];
  }


  //-----------------------------------------------------------------------------
  //                      Fetch List Data for Drop Down List
  //-----------------------------------------------------------------------------
  getCaseDomainList() {
    this.http.get("api/BcpDomain/DomainList", this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        //this.Case_DomainList = result.json();
        this.DomainList = result;
      });
  }


  getCaseStatusList(selectedDomain) {
    this.http.get(this.ListValueApiPath + "ByListCode/" + selectedDomain + "/STATUS", this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        //this.Case_CaseStatusList = result.json();
        this.CaseStatusList = result;
      });
  }


  getCaseSeverityList(selectedDomain) {
    this.http.get(this.ListValueApiPath + "ByListCode/" + selectedDomain + "/SEVERITY", this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        //this.Case_SeverityList = result.json();
        this.SeverityList = result;
      });
  }

  getReportsList() {
    this.http.get(this.PrimaryApiPath + "GetFullList/", this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        //this.Case_SeverityList = result.json();
        this.Reports_List = result;
      });
  }

  getReportNamebyTab(tabName) {
    this.http.get(this.PrimaryApiPath + "GetReportNamebyTab/" + tabName, this.bcp.getHttpOptions())
      .subscribe((result: any) => {
        this.selectedReportName = result;
      });
  }


  //-----------------------------------------------------------------------------
  //                                  Show Report
  //-----------------------------------------------------------------------------
  tabViewChanged(event, tabView: TabView) {
    this.selectedTab = tabView.tabs[event.index].header;
    this.getReportNamebyTab(this.selectedTab);
    this.refreshSearchFields();
  }


  refreshSearchFields() {
    if (this.selectedTab == "Outstanding List") {
      this.ShowSearchFields = true;
      this.ShowOutstandingList = true;
      this.ShowDetailsReport = false;
      this.ShowSLAReport = false;

    } else if (this.selectedTab == "Details Report") {
      this.ShowSearchFields = true;
      this.ShowOutstandingList = false;
      this.ShowDetailsReport = true;
      this.ShowSLAReport = false;

    } else if (this.selectedTab == "SLA Report") {
      this.ShowSearchFields = true;
      this.ShowOutstandingList = false;
      this.ShowDetailsReport = false;
      this.ShowSLAReport = true;

    }
  }


  getReport() {
    if (this.selectedTab == "Outstanding List") {
      this.getOustandingList();
    } else if (this.selectedTab == "Details Report") {
      this.getDetailsReport();
    } else if (this.selectedTab == "SLA Report") {
      this.getSLAReport();
    }
  }


  //Outstanding Case Outstanding List
  getOustandingList() {
    this.ShowOutstandingList = true;
    this.ShowDetailsReport = false;
    this.ShowSLAReport = false;
    if (this.SearchFieldHolder.fromDate == null) {
      this.SearchFieldHolder.fromDate = "";
    }
    if (this.SearchFieldHolder.toDate == null) {
      this.SearchFieldHolder.toDate = "";
    }
    this.stringifyValue = JSON.stringify(this.SearchFieldHolder);
    this.http.post(this.PrimaryApiPath + "outstandingSeverityPerformance/", this.stringifyValue, this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.OutstandingSeverityList = result;

        if (this.OutstandingSeverityList.length > 0) {
          for (var i = 0; i < this.OutstandingSeverityList.length; i++) {
            //Format Date to YYYY-MM-DD
            if (this.OutstandingSeverityList[i].createDate != null) {
              this.OutstandingSeverityList[i].createDate = this.OutstandingSeverityList[i].createDate.slice(0, 10);
            }
            if (this.OutstandingSeverityList[i].targetDate != null) {
              this.OutstandingSeverityList[i].targetDate = this.OutstandingSeverityList[i].targetDate.slice(0, 10);
            }
          }
        }
      });
  }


  //Support Case Details Report
  getDetailsReport() {
    this.ShowDetailsReport = true;
    this.ShowOutstandingList = false;
    this.ShowSLAReport = false;
    if (this.SearchFieldHolder.fromDate == null) {
      this.SearchFieldHolder.fromDate = "";
    }
    if (this.SearchFieldHolder.toDate == null) {
      this.SearchFieldHolder.toDate = "";
    }
    this.stringifyValue = JSON.stringify(this.SearchFieldHolder);
    this.http.post(this.PrimaryApiPath + "caseDetailsReport/", this.stringifyValue, this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.CaseDetailsList = result;

        if (this.CaseDetailsList.length > 0) {
          for (var i = 0; i < this.CaseDetailsList.length; i++) {
            //Format Date to YYYY-MM-DD
            if (this.CaseDetailsList[i].createDate != null) {
              this.CaseDetailsList[i].createDate = this.CaseDetailsList[i].createDate.slice(0, 10);
            }
          }
        }
      });
  }


  //Support Case SLA Report
  getSLAReport() {
    this.ShowDetailsReport = false;
    this.ShowOutstandingList = false;
    this.ShowSLAReport = true;
    this.numberOfSLACases = 0;
    if (this.SearchFieldHolder.fromDate == null) {
      this.SearchFieldHolder.fromDate = "";
    }
    if (this.SearchFieldHolder.toDate == null) {
      this.SearchFieldHolder.toDate = "";
    }
    this.stringifyValue = JSON.stringify(this.SearchFieldHolder);
    this.http.post(this.PrimaryApiPath + "caseSLAReport/", this.stringifyValue, this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.CaseSLAList = result;

        if (this.CaseSLAList.length > 0) {
          for (var i = 0; i < this.CaseSLAList.length; i++) {
            //Format Output Fields
            if (this.CaseSLAList[i].issueDate != null) {
              if (this.CaseSLAList[i].issueDate.slice(0, 10) == '0001-01-01' || this.CaseSLAList[i].issueDate.slice(0, 10) == '1900-01-01') {
                this.CaseSLAList[i].issueDate = '';
              } else {
                this.CaseSLAList[i].issueDate = this.bcp.formatDateToDisplayString(this.CaseSLAList[i].issueDate, true, false, '-', ':');
              }
            }
            if (this.CaseSLAList[i].responseDate != null) {
              if (this.CaseSLAList[i].responseDate.slice(0, 10) == '0001-01-01' || this.CaseSLAList[i].responseDate.slice(0, 10) == '1900-01-01') {
                this.CaseSLAList[i].responseDate = '';
              } else {
                this.CaseSLAList[i].responseDate = this.bcp.formatDateToDisplayString(this.CaseSLAList[i].responseDate, true, false, '-', ':');
              }
            }
            if (this.CaseSLAList[i].resolutionDate != null) {
              if (this.CaseSLAList[i].resolutionDate.slice(0, 10) == '0001-01-01' || this.CaseSLAList[i].resolutionDate.slice(0, 10) == '1900-01-01') {
                this.CaseSLAList[i].resolutionDate = '';
              } else {
                this.CaseSLAList[i].resolutionDate = this.bcp.formatDateToDisplayString(this.CaseSLAList[i].resolutionDate, true, false, '-', ':');
              }
            }
            if (this.CaseSLAList[i].subTotal == "Y") {
              this.CaseSLAList[i].resolutionHour = this.CaseSLAList[i].resolutionHour + "%";
              this.CaseSLAList[i].responseHour = '';
            } else {
              this.numberOfSLACases = this.numberOfSLACases + 1;
            }
          }
        }
      });
  }


  //-----------------------------------------------------------------------------
  //                                  Export Data
  //-----------------------------------------------------------------------------

  extractData(res: string) {
    // transforme response to blob
    let myBlob: Blob = new Blob([res], { type: 'application/forcde-download' }); // replace the type by whatever type is your response

    var fileURL = URL.createObjectURL(myBlob);
    // Cross your fingers at this point and pray whatever you're used to pray
    window.open(fileURL);
  }

  exportPDF() {

    //Define PDF Custom Fonts
    pdfMake.fonts = {
      Roboto: {
        normal: 'Roboto-Regular.ttf',
        bold: 'Roboto-Medium.ttf',
        italics: 'Roboto-Italic.ttf',
        bolditalics: 'Roboto-MediumItalic.ttf'
      }
      , NotoSansTC: {
        normal: 'NotoSansTC-Regular.otf',
        bold: 'NotoSansTC-Bold.otf'
      }
    };

    //Outstanding Cases Outstanding List
    if (this.selectedTab == "Outstanding List") {

      //Re-phase filter for display
      var domainFilter = 'Domain: ' + this.SearchFieldHolder.domainId
      if (this.SearchFieldHolder.fromDate) {
        var dateFilter = 'Date: ' + this.SearchFieldHolder.fromDate.toISOString().slice(0, 10) + ' to ' + this.SearchFieldHolder.toDate.toISOString().slice(0, 10);
      } else {
        var dateFilter = 'Date: ---';
      }

      //Assign Table Header and Records into List
      var ExportOutstandingSeverityList = [];
      //Header
      ExportOutstandingSeverityList.push(['Domain', 'CaseNumber', 'Subject', 'Status', 'Severity', 'Create Date', 'Target Date', 'Remaining Percentage']);
      //Data
      this.OutstandingSeverityList.map((obj) => {
        ExportOutstandingSeverityList.push([obj.domainId, obj.caseNumber, obj.subject, obj.caseStatus, obj.severity, obj.createDate, obj.targetDate, obj.remainingPercentage])
      });

      //Assign File Name when Download
      var CurrentDateTime = new Date(this.bcp.getCurrentUTCDateTime());
      var FileDateTime = CurrentDateTime.getUTCFullYear().toString() + (CurrentDateTime.getUTCMonth() + 1).toString().padStart(2, '0') + CurrentDateTime.getUTCDate().toString().padStart(2, '0') + CurrentDateTime.getHours().toString().padStart(2, '0') + CurrentDateTime.getMinutes().toString().padStart(2, '0');
      var FileName = this.selectedReportName.toString() + "_" + FileDateTime + ".pdf";

      let docDefinition = {
        //Page Setting
        pageSize: 'A4',
        pageOrientation: 'landscape',
        //Left, Top, Right, Bottom
        pageMargins: [40, 90, 40, 30],
        info: {
          title: this.selectedReportName.toString()
        },
        //Footer
        footer: function (currentPage, pageCount) {
          return [
            {
              text: currentPage.toString() + ' of ' + pageCount,
              alignment: 'center'
            }
          ]
        },
        //Header
        header: {
          margin: [40, 15, 40, 0],
          layout: 'noBorders',
          table: {
            widths: ['*', 'auto'],
            body: [
              [
                //Left Hand Size - Report Header
                {
                  //margin: [0, 15],
                  layout: 'noBorders',
                  table: {
                    widths: '*',
                    body: [
                      [
                        {
                          text: this.selectedReportName.toString(),
                          style: 'header'
                        }
                      ],
                      [
                        {
                          text: domainFilter,
                          style: 'text'
                        }
                      ],
                      [
                        {
                          text: dateFilter,
                          style: 'text'
                        }
                      ]
                    ]
                  }
                },
                //Right Hand Size - Company Logo
                {
                  image: 'BCplus_LogoOnly.png',
                  fit: [50, 50]
                }
              ]
            ]
          }
        },
        content: [
          //Table
          {
            style: 'table',
            layout: {
              hLineWidth: function (i, node) {
                return (i === 0 || i === node.table.body.length) ? 1 : 1;
              },
              vLineWidth: function (i, node) {
                return (i === 0 || i === node.table.widths.length) ? 0 : 0;
              },
              hLineColor: function (i, node) {
                return (i === 0 || i === node.table.body.length) ? 'grey' : 'grey';
              },
              vLineColor: function (i, node) {
                return (i === 0 || i === node.table.widths.length) ? 'white' : 'white';
              },
              fillColor: function (rowIndex, node, columnIndex) {
                return (rowIndex % 2 === 0) ? '#daf7d5' : null;
              },
              fillOpacity: 0.3
            },
            table: {
              //Specifies No. of starting rows of the body is header, repeated when table is continued on the sec page
              headerRows: 1,
              //Assign the width of each column
              widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
              body: ExportOutstandingSeverityList
            }
          }
        ],
        defaultStyle: {
          font: 'NotoSansTC'
        },
        styles: {
          header: {
            font: 'Roboto',
            fontSize: 14,
            bold: true,
            color: '#3C734C',
            lineHeight: 1.25,
            decoration: 'underline'
          },
          text: {
            font: 'Roboto',
            fontSize: 12,
            lineHeight: 1.25
          },
          table: {
            fontSize: 10
          }
        }
      };

      pdfMake.createPdf(docDefinition).open();
      pdfMake.createPdf(docDefinition).download(FileName);
    }


  }

  //-----------------------------------------------------------------------------
  //                            Report
  //-----------------------------------------------------------------------------

  printReport() {
    if (this.selectedTab == "Outstanding List") {
      this.printOutstandingList();
    } else if (this.selectedTab == "Details Report") {
      this.printCaseDetails();
    } else if (this.selectedTab == "SLA Report") {
      this.printSLAReport();
    }
  }


  async printOutstandingList() {

    let fileReader = new FileReader();
    let strLine: string;
    const url = "https://sheetjs.com/data/executive.json";
    var tmpStr: string;
    let preCompanyCode: string = "";
    let hLines = 10;

    this.listLength1 = 0;

    this.processingReport = "OutstandingList";
    this.processingFlag = "Y";
    //get the report data
    if (this.SearchFieldHolder.fromDate == null) {
      this.SearchFieldHolder.fromDate = "";
    }
    if (this.SearchFieldHolder.toDate == null) {
      this.SearchFieldHolder.toDate = "";
    }
    this.stringifyValue = JSON.stringify(this.SearchFieldHolder);
    let reportList = await this.http.post(this.PrimaryApiPath + "outstandingSeverityPerformance/", this.stringifyValue, this.bcp.getHttpOptions())
      .map((response: any[]) => response).toPromise();
    this.listLength1 = reportList.length;
    //initial the worksheet and workbook
    this.strLine = "";
    this.updateExcelRow();
    let worksheet = XLSX.utils.json_to_sheet(this.excelRow, { header: [""], skipHeader: true });
    let workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "OutstandingList");

    //Header Fields
    if (1 == 1) {
      //output the data
      this.strLine = "Support Case Outstanding List";
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

      this.strLine = " ";
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

      this.strLine = "Domain Id: , " + this.SearchFieldHolder["domainId"];
      this.strLine = this.strLine.replace(/,/gi, this.delimiter);
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

      this.strLine = " ";
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

      this.strLine = "Print Date: , " + this.bcp.getCurrentDate();
      this.strLine = this.strLine.replace(/,/gi, this.delimiter);
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

      this.strLine = " ";
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

      this.strLine = "Creation From: , " + this.bcp.convertCalendarDateToJson(this.SearchFieldHolder["fromDate"]);
      this.strLine = this.strLine.replace(/,/gi, this.delimiter);
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

      this.strLine = "Creation To: , " + this.bcp.convertCalendarDateToJson(this.SearchFieldHolder["toDate"]);
      this.strLine = this.strLine.replace(/,/gi, this.delimiter);
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

      this.strLine = " ";
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });
    }
    for (var i = 0; i < reportList.length; i++) {
      //write heading lines
      if (i == 0) {
        //write log header line
        this.strLine = "";
        this.strLine = "Domain Id, Case Number, Subject, Status, Severity, Create Date, Target Date, Description";
        this.strLine = this.strLine.replace(/,/gi, this.delimiter);
        this.updateExcelRow();
        XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });
      }
      //write company code line
      this.strLine = "";
      this.strLine = this.strLine + reportList[i].domainId
        + this.delimiter + reportList[i].caseNumber
        + this.delimiter + reportList[i].subject
        + this.delimiter + reportList[i].caseStatus
        + this.delimiter + reportList[i].severity
        + this.delimiter + this.bcp.formatDateToDisplayString(reportList[i].createDate, true, false, '-', ':')
        + this.delimiter + this.bcp.formatDateToDisplayString(reportList[i].targetDate, true, false, '-', ':')
        + this.delimiter + reportList[i].longDescription;
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });
    }
    //total section
    this.strLine = " ";
    this.updateExcelRow();
    XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

    this.strLine = "No. of Cases: ," + reportList.length;
    this.strLine = this.strLine.replace(/,/gi, this.delimiter);
    this.updateExcelRow();
    XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

    //worksheet["C"+11].s = {
    //  alignment: { vertical: 'middle', wrapText: true }
    //};

    this.fixWidth_Outstanding(worksheet);
    this.applyCellFormat_Outstanding(worksheet);

    XLSX.writeFile(workbook, "Report_OutstandingCases.xlsx", { compression: true });
    this.processingFlag = "N";
    this.processingReport = "";
  }


  async printCaseDetails() {

    let fileReader = new FileReader();
    let strLine: string;
    const url = "https://sheetjs.com/data/executive.json";
    var tmpStr: string;
    let preCompanyCode: string = "";
    let hLines = 10;

    this.listLength1 = 0;

    this.processingReport = "CaseDetails";
    this.processingFlag = "Y";
    //get the report data
    if (this.SearchFieldHolder.fromDate == null) {
      this.SearchFieldHolder.fromDate = "";
    }
    if (this.SearchFieldHolder.toDate == null) {
      this.SearchFieldHolder.toDate = "";
    }
    this.stringifyValue = JSON.stringify(this.SearchFieldHolder);
    let reportList = await this.http.post(this.PrimaryApiPath + "caseDetailsReport/", this.stringifyValue, this.bcp.getHttpOptions())
      .map((response: any[]) => response).toPromise();
    this.listLength1 = reportList.length;
    //initial the worksheet and workbook
    this.strLine = "";
    this.updateExcelRow();
    let worksheet = XLSX.utils.json_to_sheet(this.excelRow, { header: [""], skipHeader: true });
    let workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "CaseDetails");

    //Header Fields
    if (1 == 1) {
      //output the data
      this.strLine = "Support Case Details Report";
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

      this.strLine = " ";
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

      this.strLine = "Domain Id: , " + this.SearchFieldHolder["domainId"];
      this.strLine = this.strLine.replace(/,/gi, this.delimiter);
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

      this.strLine = " ";
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

      this.strLine = "Print Date: , " + this.bcp.getCurrentDate();
      this.strLine = this.strLine.replace(/,/gi, this.delimiter);
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

      this.strLine = " ";
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

      this.strLine = "Creation From: , " + this.bcp.convertCalendarDateToJson(this.SearchFieldHolder["fromDate"]);
      this.strLine = this.strLine.replace(/,/gi, this.delimiter);
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

      this.strLine = "Creation To: , " + this.bcp.convertCalendarDateToJson(this.SearchFieldHolder["toDate"]);
      this.strLine = this.strLine.replace(/,/gi, this.delimiter);
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

      this.strLine = " ";
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });
    }
    for (var i = 0; i < reportList.length; i++) {
      //write heading lines
      if (i == 0) {
        //write log header line
        this.strLine = "";
        this.strLine = "Case Number, Create Date, Description, Service Type, Category, Severity, Status, Resolution, Object, Client Reference";
        this.strLine = this.strLine.replace(/,/gi, this.delimiter);
        this.updateExcelRow();
        XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });
      }
      //write company code line
      this.strLine = "";
      this.strLine = this.strLine + reportList[i].caseNumber
        + this.delimiter + this.bcp.formatDateToDisplayString(reportList[i].createDate, true, false, '-', ':')
        + this.delimiter + reportList[i].longDescription
        + this.delimiter + reportList[i].serviceType
        + this.delimiter + reportList[i].subCategory1
        + this.delimiter + reportList[i].severity
        + this.delimiter + reportList[i].caseStatus
        + this.delimiter + reportList[i].resolution
        + this.delimiter + reportList[i].technicalRemark
        + this.delimiter + reportList[i].clientReferenceNumber;
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });
    }
    //total section
    //this.strLine = " ";
    //this.updateExcelRow();
    //XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

    //this.strLine = "No. of Lines: ," + detailList.length;
    //this.strLine = this.strLine.replace(/,/gi, this.delimiter);
    //this.updateExcelRow();
    //XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

    //worksheet["C"+11].s = {
    //  alignment: { vertical: 'middle', wrapText: true }
    //};

    this.fixWidth(worksheet);
    this.applyCellFormat(worksheet);

    XLSX.writeFile(workbook, "Report_CaseDetails.xlsx", { compression: true });
    this.processingFlag = "N";
    this.processingReport = "";
  }


  async printSLAReport() {

    let fileReader = new FileReader();
    let strLine: string;
    const url = "https://sheetjs.com/data/executive.json";
    var tmpStr: string;
    let preCompanyCode: string = "";
    let hLines = 10;
    this.numberOfSLACases = 0;
    this.cellList = [];

    this.listLength1 = 0;

    this.processingReport = "SLAReport";
    this.processingFlag = "Y";
    //get the report data
    if (this.SearchFieldHolder.fromDate == null) {
      this.SearchFieldHolder.fromDate = "";
    }
    if (this.SearchFieldHolder.toDate == null) {
      this.SearchFieldHolder.toDate = "";
    }
    this.stringifyValue = JSON.stringify(this.SearchFieldHolder);
    let reportList = await this.http.post(this.PrimaryApiPath + "caseSLAReport/", this.stringifyValue, this.bcp.getHttpOptions())
      .map((response: any[]) => response).toPromise();
    this.listLength1 = reportList.length;
    //initial the worksheet and workbook
    this.strLine = "";
    this.updateExcelRow();
    let worksheet = XLSX.utils.json_to_sheet(this.excelRow, { header: [""], skipHeader: true });
    let workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "CaseSLAReport");

    //Header Fields
    if (1 == 1) {
      //output the data
      this.strLine = "Support Case SLA Report";
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

      this.strLine = " ";
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

      this.strLine = "Domain Id: , " + this.SearchFieldHolder["domainId"];
      this.strLine = this.strLine.replace(/,/gi, this.delimiter);
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

      this.strLine = " ";
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

      this.strLine = "Print Date: , " + this.bcp.getCurrentDate();
      this.strLine = this.strLine.replace(/,/gi, this.delimiter);
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

      this.strLine = " ";
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

      this.strLine = "Issued From: , " + this.bcp.convertCalendarDateToJson(this.SearchFieldHolder["fromDate"]);
      this.strLine = this.strLine.replace(/,/gi, this.delimiter);
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

      this.strLine = "Issued To: , " + this.bcp.convertCalendarDateToJson(this.SearchFieldHolder["toDate"]);
      this.strLine = this.strLine.replace(/,/gi, this.delimiter);
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

      this.strLine = " ";
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });
    }
    for (var i = 0; i < reportList.length; i++) {
      //write heading lines
      if (i == 0) {
        //write log header line
        this.strLine = "";
        this.strLine = "Case Number, Issue Date, Complexity, Severity, Service Type, Status, Subject, Response Date, Response Hour, Resolution Date, Resolution Hour";
        this.strLine = this.strLine.replace(/,/gi, this.delimiter);
        this.updateExcelRow();
        XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });
      }
      //format data before write line
      if (reportList[i].issueDate != null) {
        if (reportList[i].issueDate.slice(0, 10) == '0001-01-01' || reportList[i].issueDate.slice(0, 10) == '1900-01-01') {
          reportList[i].issueDate = ' ';
        } else {
          reportList[i].issueDate = this.bcp.formatDateToDisplayString(reportList[i].issueDate, true, false, '-', ':');
        }
      }
      if (reportList[i].responseDate != null) {
        if (reportList[i].responseDate.slice(0, 10) == '0001-01-01' || reportList[i].responseDate.slice(0, 10) == '1900-01-01') {
          reportList[i].responseDate = ' ';
        } else {
          reportList[i].responseDate = this.bcp.formatDateToDisplayString(reportList[i].responseDate, true, false, '-', ':');
        }
      }
      if (reportList[i].resolutionDate != null) {
        if (reportList[i].resolutionDate.slice(0, 10) == '0001-01-01' || reportList[i].resolutionDate.slice(0, 10) == '1900-01-01') {
          reportList[i].resolutionDate = ' ';
        } else {
          reportList[i].resolutionDate = this.bcp.formatDateToDisplayString(reportList[i].resolutionDate, true, false, '-', ':');
        }
      }
      if (reportList[i].subTotal == "Y") {
        reportList[i].resolutionHour = reportList[i].resolutionHour + "%";
        reportList[i].responseHour = ' ';
        this.addRangeToCellList("K", hLines + 2 + i, "K", hLines + 2 + i, true);
        //console.log("line number is " + i);
      } else {
        this.numberOfSLACases = this.numberOfSLACases + 1;
      }
      //write detail line
      this.strLine = "";
      this.strLine = this.strLine + reportList[i].caseNumber
        + this.delimiter + reportList[i].issueDate
        + this.delimiter + reportList[i].caseComplexity
        + this.delimiter + reportList[i].severity
        + this.delimiter + reportList[i].serviceType
        + this.delimiter + reportList[i].caseStatus
        + this.delimiter + reportList[i].subject
        + this.delimiter + reportList[i].responseDate
        + this.delimiter + reportList[i].responseHour
        + this.delimiter + reportList[i].resolutionDate
        + this.delimiter + reportList[i].resolutionHour;
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });
    }
    //total section
    this.strLine = " ";
    this.updateExcelRow();
    XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

    this.strLine = "No. of Cases: ," + this.numberOfSLACases;
    this.strLine = this.strLine.replace(/,/gi, this.delimiter);
    this.updateExcelRow();
    XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

    //worksheet["C"+11].s = {
    //  alignment: { vertical: 'middle', wrapText: true }
    //};

    //highlight percentage
    this.formatCell(worksheet, this.cellList, "BGCOLOR_01");

    this.fixWidth_SLA(worksheet);
    this.applyCellFormat_SLA(worksheet);

    XLSX.writeFile(workbook, "Report_SLA_Report.xlsx", { compression: true });
    this.processingFlag = "N";
    this.processingReport = "";
  }


  updateExcelRow() {
    const colIndexArray = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];
    let dataArray: string[];
    this.excelRow = [];
    this.strLine = this.strLine.replace(/undefined/gi, "");
    this.strLine = this.strLine.replace(/Null/gi, "");
    this.strLine = this.strLine.replace(/null/gi, "");
    dataArray = this.strLine.split(this.delimiter);
    for (let index = 0; index < dataArray.length; index += 1) {
      this.excelRow[index] = dataArray[index];
    }
  }


  fixWidth_Outstanding(worksheet: XLSX.WorkSheet) {
    const data = XLSX.utils.sheet_to_json<any>(worksheet)
    const wscols = [
      { width: 15 }, { width: 20 }, { width: 80 }, { width: 15 }, { width: 20 }, //ABCDE
      { width: 25 }, { width: 25 }, { width: 80 }, { width: 25 }, { width: 25 }, //FGHIJ
      { width: 25 }, { width: 25 }, { width: 25 }, { width: 25 }, { width: 25 }, //KLMNO
      { width: 25 }, { width: 25 }, { width: 25 }, { width: 25 },//PQRST
      //UVWXYZ
    ];
    worksheet["!cols"] = wscols;
    this.lastRowNumber = data.length + 1;
  }


  fixWidth(worksheet: XLSX.WorkSheet) {
    const data = XLSX.utils.sheet_to_json<any>(worksheet)
    const wscols = [
      { width: 15 }, { width: 20 }, { width: 80 }, { width: 20 }, { width: 20 }, //ABCDE
      { width: 10 }, { width: 15 }, { width: 80 }, { width: 25 }, { width: 25 }, //FGHIJ
      { width: 25 }, { width: 25 }, { width: 25 }, { width: 25 }, { width: 25 }, //KLMNO
      { width: 25 }, { width: 25 }, { width: 25 }, { width: 25 },//PQRST
      //UVWXYZ
    ];
    worksheet["!cols"] = wscols;
    this.lastRowNumber = data.length + 1;
  }


  fixWidth_SLA(worksheet: XLSX.WorkSheet) {
    const data = XLSX.utils.sheet_to_json<any>(worksheet)
    const wscols = [
      { width: 15 }, { width: 20 }, { width: 15 }, { width: 15 }, { width: 20 }, //ABCDE
      { width: 15 }, { width: 80 }, { width: 20 }, { width: 15 }, { width: 20 }, //FGHIJ
      { width: 15 }, { width: 25 }, { width: 25 }, { width: 25 }, { width: 25 }, //KLMNO
      { width: 25 }, { width: 25 }, { width: 25 }, { width: 25 },//PQRST
      //UVWXYZ
    ];
    worksheet["!cols"] = wscols;
    this.lastRowNumber = data.length + 1;
  }


  colIndexToChar(colIndex) {
    let result: string = "";
    let adjustFlag = (colIndex - (Math.floor(colIndex / 26) * 26)) === 0 ? 1 : 0; // for AZ/BZ ... handling

    if (colIndex <= 26) {
      result = String.fromCharCode(colIndex + 64);
    } else {
      result = String.fromCharCode(Math.floor((colIndex - adjustFlag) / 26) + 64); //assume max column is ZZ
      result = result + String.fromCharCode(colIndex - (Math.floor((colIndex - adjustFlag) / 26) * 26) + 64);
    }
    return result;
  }


  charToColIndex(colName) {
    let result = 0;
    if (colName.length == 1) {
      result = colName.charCodeAt(0) - 64
    } else {
      result = (colName[0].charCodeAt(0) - 64) * 26;
      result = result + colName[1].charCodeAt(0) - 64;
    }
    return result;
  }


  addRangeToCellList(startCol, startRow, endCol, endRow, appendFlag) {
    let startColIndex = this.charToColIndex(startCol);
    let endColIndex = this.charToColIndex(endCol);
    let currCell: string;
    if (!appendFlag || this.cellList == null || this.cellList == undefined) {
      this.cellList = [];
    }

    for (let c = startColIndex; c <= endColIndex; c++) {
      for (let r = startRow; r <= endRow; r++) {
        this.cellList.push(this.colIndexToChar(c) + r);
      }

    }
  }


  formatCell(worksheet: XLSX.WorkSheet, localCellList: string[]
    , formatRule: string) {

    let defaultStyle = {
      font: {
        bold: false,
        italic: false,
        underline: false
      },
      border: {
        top: { style: "none", color: { auto: 1 } },
        right: { style: "none", color: { auto: 1 } },
        bottom: { style: "none", color: { auto: 1 } },
        left: { style: "none", color: { auto: 1 } }
      },
      alignment: {
        vertical: 'top',
        wrapText: false
      }
    };

    let newStyle = JSON.parse(JSON.stringify(defaultStyle));
    let originalStyle = JSON.parse(JSON.stringify(defaultStyle));

    const fontSetting01 = {
      bold: true,
      italic: false,
      underline: false
    };

    const fontSetting02 = {
      bold: true,
      italic: false,
      underline: true
    };

    const borderSetting01 = {
      top: { style: "thin", color: { auto: 1 } },
      right: { style: "thin", color: { auto: 1 } },
      bottom: { style: "thin", color: { auto: 1 } },
      left: { style: "thin", color: { auto: 1 } }
    };

    const bgcolorSetting01 = {
      patternType: "solid",
      //fgColor: { rgb: "e6f7eb" }
      fgColor: { rgb: "f7f372" }
    }

    for (let i = 0; i < localCellList.length; i++) {
      //cache the original style of the cell

      if (worksheet[localCellList[i]] !== undefined) {
        if (formatRule === "BOLD" || formatRule === "BORDER"
          || formatRule === "BGCOLOR_01" || formatRule === "WRAPTEXT" || formatRule === "TOP"
          || formatRule === "BOLDUNDERLINE") {
          newStyle = JSON.parse(JSON.stringify(defaultStyle));
          originalStyle = JSON.parse(JSON.stringify(defaultStyle));
          if (worksheet[localCellList[i]].s !== undefined) {
            originalStyle = JSON.parse(JSON.stringify(worksheet[localCellList[i]].s));
          }

          if (originalStyle.font !== undefined) {
            newStyle.font = originalStyle.font;
          }
          if (originalStyle.border !== undefined) {
            newStyle.border = originalStyle.border;
          }
          if (originalStyle.fill !== undefined) {
            newStyle.fill = originalStyle.fill;
          }

          if (formatRule === "BOLD") {
            newStyle.font = fontSetting01;
          }

          if (formatRule === "BOLDUNDERLINE") {
            newStyle.font = fontSetting02;
          }

          if (formatRule === "BORDER") {
            newStyle.border = borderSetting01;
          }

          if (formatRule === "BGCOLOR_01") {
            newStyle.fill = bgcolorSetting01;
          }

          if (formatRule === "WRAPTEXT") {
            newStyle.alignment = { wrapText: true };
          }

          if (formatRule === "TOP") {
            newStyle.alignment = { vertical: 'top' };
          }

          worksheet[localCellList[i]].s = newStyle;
        }

        if (formatRule === "AMOUNT") {
          worksheet[localCellList[i]].t = "n"; //  change format
          worksheet[localCellList[i]].z = "_($* #,##0.00_);_($* (#,##0.00);_($* -??_);_(@_)";
        }

        if (formatRule === "NUMBER") {
          worksheet[localCellList[i]].t = "n"; //  change format
          worksheet[localCellList[i]].z = "0.00";
        }

        if (formatRule === "NUMBER_4DP") {
          worksheet[localCellList[i]].t = "n"; //  change format
          worksheet[localCellList[i]].z = "0.0000";
        }

        if (formatRule === "PERCENT") {
          worksheet[localCellList[i]].t = "n"; //  change format
          worksheet[localCellList[i]].z = "0.00%";
        }
      } else {
        //console.log("Error when Formatting Cell " + localCellList[i]);
      }
    }



  }//formatCell end


  applyCellFormat_Outstanding(worksheet: XLSX.WorkSheet) {

    //Format Cell as Bold with Border
    let tmpList = [];
    this.cellList = [];

    //bold
    this.addRangeToCellList("A", 2, "K", 11, true);
    this.formatCell(worksheet, this.cellList, "BOLD");

    //bgcolor
    this.cellList = [];
    this.addRangeToCellList("A", 11, "K", 11, true);
    this.formatCell(worksheet, this.cellList, "BGCOLOR_01");

    //border
    this.cellList = [];
    this.addRangeToCellList("A", 11, "K", this.lastRowNumber, true);
    this.formatCell(worksheet, this.cellList, "BORDER");

    //wraptext
    this.cellList = [];
    this.addRangeToCellList("G", 12, "G", this.lastRowNumber, true);
    this.formatCell(worksheet, this.cellList, "WRAPTEXT");

    this.cellList = [];
    this.addRangeToCellList("G", 12, "G", this.lastRowNumber, true);
    this.formatCell(worksheet, this.cellList, "TOP");

    //worksheet["C13"].s = {
    //  alignment: { vertical: 'middle', wrapText: true }
    //};

    //amount with 2dp
    //aware if any space before the cell value
    //tmpList = ["D11"];
    //this.cellList = [];
    //this.addRangeToCellList("E", 11, "S", this.lastRowNumber, true);
    //this.formatCell(worksheet, this.cellList, "AMOUNT");

    //Number in 2dp
    tmpList = [""];
    //this.addListToCellList(tmpList, false);
    //this.formatCell(worksheet, this.cellList, "NUMBER");

    //percent in 2dp
    tmpList = [""];
    //this.formatCell(worksheet, this.cellList, "PERCENT");

  };


  applyCellFormat(worksheet: XLSX.WorkSheet) {

    //Format Cell as Bold with Border
    let tmpList = [];
    this.cellList = [];

    //bold
    this.addRangeToCellList("A", 2, "J", 11, true);
    this.formatCell(worksheet, this.cellList, "BOLD");

    //bgcolor
    this.cellList = [];
    this.addRangeToCellList("A", 11, "J", 11, true);
    this.formatCell(worksheet, this.cellList, "BGCOLOR_01");

    //border
    this.cellList = [];
    this.addRangeToCellList("A", 11, "J", this.lastRowNumber, true);
    this.formatCell(worksheet, this.cellList, "BORDER");

    //wraptext
    this.cellList = [];
    this.addRangeToCellList("C", 12, "C", this.lastRowNumber, true);
    this.formatCell(worksheet, this.cellList, "WRAPTEXT");

    this.cellList = [];
    this.addRangeToCellList("H", 12, "H", this.lastRowNumber, true);
    this.formatCell(worksheet, this.cellList, "WRAPTEXT");

    this.cellList = [];
    this.addRangeToCellList("C", 12, "C", this.lastRowNumber, true);
    this.formatCell(worksheet, this.cellList, "TOP");

    this.cellList = [];
    this.addRangeToCellList("H", 12, "H", this.lastRowNumber, true);
    this.formatCell(worksheet, this.cellList, "TOP");

    //worksheet["C13"].s = {
    //  alignment: { vertical: 'middle', wrapText: true }
    //};

    //amount with 2dp
    //aware if any space before the cell value
    //tmpList = ["D11"];
    //this.cellList = [];
    //this.addRangeToCellList("E", 11, "S", this.lastRowNumber, true);
    //this.formatCell(worksheet, this.cellList, "AMOUNT");

    //Number in 2dp
    tmpList = [""];
    //this.addListToCellList(tmpList, false);
    //this.formatCell(worksheet, this.cellList, "NUMBER");

    //percent in 2dp
    tmpList = [""];
    //this.formatCell(worksheet, this.cellList, "PERCENT");

  };


  applyCellFormat_SLA(worksheet: XLSX.WorkSheet) {

    //Format Cell as Bold with Border
    let tmpList = [];
    this.cellList = [];

    //bold
    this.addRangeToCellList("A", 2, "K", 11, true);
    this.formatCell(worksheet, this.cellList, "BOLD");

    //bgcolor
    this.cellList = [];
    this.addRangeToCellList("A", 11, "K", 11, true);
    this.formatCell(worksheet, this.cellList, "BGCOLOR_01");

    //border
    this.cellList = [];
    this.addRangeToCellList("A", 11, "K", this.lastRowNumber, true);
    this.formatCell(worksheet, this.cellList, "BORDER");

    //wraptext
    this.cellList = [];
    this.addRangeToCellList("G", 12, "G", this.lastRowNumber, true);
    this.formatCell(worksheet, this.cellList, "WRAPTEXT");

    this.cellList = [];
    this.addRangeToCellList("G", 12, "G", this.lastRowNumber, true);
    this.formatCell(worksheet, this.cellList, "TOP");

    //worksheet["C13"].s = {
    //  alignment: { vertical: 'middle', wrapText: true }
    //};

    //amount with 2dp
    //aware if any space before the cell value
    //tmpList = ["D11"];
    //this.cellList = [];
    //this.addRangeToCellList("E", 11, "S", this.lastRowNumber, true);
    //this.formatCell(worksheet, this.cellList, "AMOUNT");

    //Number in 2dp
    tmpList = [""];
    //this.addListToCellList(tmpList, false);
    //this.formatCell(worksheet, this.cellList, "NUMBER");

    //percent in 2dp
    tmpList = [""];
    //this.formatCell(worksheet, this.cellList, "PERCENT");

  };

  //-----------------------------------------------------------------------------
  //                      Checking/ Other Actions
  //-----------------------------------------------------------------------------

  //sorting event trigger, default is sorting by id
  changeSort(event) {
    if (!event.order) {
      this.sortF = 'id';
    } else {
      this.sortF = event.field;
    }
  }


  clearAllMessage() {
    this.searchErrorMsgs = [];
    this.InputErrorMsg = [];
    this.resultMsgs = [];
  }

  //Redirect to edit case page when click from report module
  editRecord(caseId) {
    this.router.navigate(['/home/case'], { queryParams: { caseId: caseId, report: "outstandingSeverity" } });
  }

}


interface IOutstandingSeverity {
  id?;
  domainId?;
  caseNumber?;
  subject?;
  caseStatus?;
  severity?;
  createDate?;
  targetDate?;
  longDescription?;
  remainingPercentage?;
}

interface IDetailsReport {
  caseNumber?;
  createDate?;
  longDescription?;
  serviceType?;
  subCategory1?;
  severity?;
  caseStatus?;
  resolution?;
  technicalRemark?;
  clientReferenceNumber?;
}

interface ISLAReport {
  seq?;
  caseNumber?;
  issueDate?;
  caseComplexity?;
  severity?;
  serviceType?;
  caseStatus?;
  subject?;
  responseDate?;
  responseHour?;
  resolutionDate?;
  resolutionHour?;
  subTotal?;
}

interface IDomainValue {
  label?;
  value?;
}

interface ICodeValue {
  label?;
  value?;
}

interface Message {
}

interface IReportsListValue {
  tabName?;
  reportName?;
}

interface ISeveritySearchFields {
  domainId?;
  fromDate?;
  toDate?;
}
